import useTranslation from "@babackapp/translations/use-translation";
import { FastmagIntegrationPreview } from "./fastmag";
import { GorgiasIntegrationPreview } from "./gorgias";
import { IntegrationPreviewsContainer } from "./integration-preview";
import { KlaviyoIntegrationPreview } from "./klaviyo";
import { OnestockIntegrationPreview } from "./oneStock";
import { ShippingBoIntegrationPreview } from "./shippingBo";
import { SplioIntegrationPreview } from "./splio";
import { StripeIntegrationPreview } from "./stripe";
import { ZendeskIntegrationPreview } from "./zendesk";
export default function ThirdPartSoftware() {
  const t = useTranslation();

  return (
    <>
      <div className="space-y-6 mt-8">
        <div className="space-y-6 ">
          <div className="flex">
            <div className="flex-1">
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                {t("settings.integrations.thirdpart.title")}
              </h3>
              <p className="mt-1 max-w-2xl text-sm text-gray-500">
                {t("settings.integrations.thirdpart.subtitle")}
              </p>
            </div>
          </div>
        </div>

        <IntegrationPreviewsContainer>
          <StripeIntegrationPreview />
          <ZendeskIntegrationPreview />
          <KlaviyoIntegrationPreview />
          <GorgiasIntegrationPreview />
          <FastmagIntegrationPreview />
          <OnestockIntegrationPreview />
          <SplioIntegrationPreview />
          <ShippingBoIntegrationPreview />
        </IntegrationPreviewsContainer>
      </div>
    </>
  );
}
